export default localStorage || window.localStorage;
